import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent, type IconDefinition } from '@fortawesome/angular-fontawesome';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'rcp-text-link-action',
  template: `
    <a
      class="text-link-action clickable"
      [attr.target]="target() === 'external' ? '_blank' : null"
      [attr.rel]="target() === 'external' ? 'noopener noreferrer' : null"
      [attr.href]="href()"
    >
      <ng-content></ng-content>
      @if (icon() || target() === 'external') {
        <span class="button-icon">
          <fa-icon [icon]="target() === 'external' ? faExternalLink : icon()" />
        </span>
      }
    </a>
  `,
  styles: `
    :host {
      /* can't do display contents, because then no events are emitted */
      /* like click, or Intersection observers */
      display: inline-flex;
    }

    .text-link-action {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: var(--item-internal-spacing-sm);
      color: var(--col-text-secondary);
      text-decoration: underline;
      font-weight: var(--font-weight-semi-bold);
      font-size: var(--font-size-small);
      transition: color 300ms ease-in-out;

      &:hover,
      &:focus {
        color: var(--col-primary);
      }
    }

    .button-icon {
      margin-left: auto;
      align-self: stretch;
      height: auto;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      font-size: var(--font-size-icon-small);
    }
  `,
  imports: [FaIconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TextLinkActionComponent {
  href = input<string>();
  icon = input<IconDefinition>();
  target = input<'external' | 'internal'>('internal');
  protected readonly faExternalLink = faExternalLink;
}
